<div class="container-fluid">
  <div class="row">
    <div class="col-6">
      <h1>{{song.artist}} - {{song.title}}</h1>
    </div>
    <div class="col-6 d-print-none">
      <div (click)="graph = !graph">
        <fa-icon [icon]="graph ? fa.on : fa.off"></fa-icon>
        Chords
      </div>
      <div (click)="instrument = instrument === 'guitar' ? 'ukulele' : 'guitar'">
        <fa-icon [icon]="instrument === 'guitar' ? fa.on : fa.off"></fa-icon>
        Guitar
      </div>
      <div *ngIf="graph">
        <fa-icon [icon]="fa.dec" (click)="chordSize = -10"></fa-icon>
        Chord size ({{chordSize}})
        <fa-icon [icon]="fa.inc" (click)="chordSize = +10"></fa-icon>
      </div>
      <div>
        <fa-icon [icon]="fa.dec" (click)="trans[instrument] = trans[instrument] - 1"></fa-icon>
        <span>Trans {{instrument}} {{trans[instrument]}}</span>
        <fa-icon [icon]="fa.inc" (click)="trans[instrument] = trans[instrument] + 1"></fa-icon>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-1 section">Chords:</div>
    <div class="col-11 section">
      <app-chord-render *ngFor="let chord of chordList" [size]="100" [chord]="transpond(chord, trans[instrument])" [instrument]="instrument" [graph]="!graph"></app-chord-render>
    </div>
  </div>

  <div class="row songbar">
    <div class="section col-sm-12 col-md-6" *ngFor="let bars of song.bars">
      <div class="part" *ngFor="let bar of bars" [ngClass]="{'chapter': !!bar.chapter || (!bar.chord && !bar.text)}">
        <ng-container *ngIf="!!bar.chapter || bar.chord || bar.text">
          <span class="text" *ngIf="bar.chapter">{{bar.chapter}}</span>
          <app-chord-render *ngIf="bar.chord" [size]="chordSize" [chord]="transpond(bar.chord, trans[instrument])" [instrument]="instrument" [graph]="graph"></app-chord-render><br>
          <span class="text">&nbsp;{{bar.text}}</span>
        </ng-container>
      </div>
    </div>
  </div>
</div>
